module.exports = __webpack_public_path__ + "static/media/grand_mum_friend_eye_blink_04.6c9e3295.png";